export const UPDATE_SELECTED_LANGUAGE_KEY = 'UPDATE_SELECTED_LANGUAGE_KEY';
export const UPDATE_MULTILINGUAL_ROUTES = 'UPDATE_MULTILINGUAL_ROUTES';
export const UPDATE_HAS_ACCEPTED_POLICY = 'UPDATE_HAS_ACCEPTED_POLICY';
export const UPDATE_SEARCH_RESULTS = 'UPDATE_SEARCH_RESULTS';
export const UPDATE_SEARCH_RESULTS_COUNT = 'UPDATE_SEARCH_RESULTS_COUNT';
